import { useQuery } from "@tanstack/react-query";
import {
	getRFactorPerStand,
	getRFactorPickers,
} from "../repositories/RFactorPerStandRepository";

const NO_POLLING = {
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
} as const;

interface UseRFactorPerStandParams {
	start: string;
	end: string;
	productSizeId: number | null;
	standId: number | null;
	crewId: string | null;
}

export const useRFactorPerStandData = ({
	start,
	end,
	productSizeId,
	standId,
	crewId,
}: UseRFactorPerStandParams) =>
	useQuery({
		queryKey: ["rfactorPerStand", start, end, productSizeId, standId, crewId],
		queryFn: ({ signal }) =>
			getRFactorPerStand({
				start,
				end,
				productSizeId: productSizeId as number,
				standId: standId as number,
				crewId,
				signal,
			}),
		enabled: productSizeId != null && standId != null,
		...NO_POLLING,
	});

// The lists are whatever was rolled in the range, so they move with the dates.
//
// keepPreviousData is not a nicety here: without it the lists empty out while the
// new range is in flight, which drops the selected product, which cancels the
// series query — so moving a date by one day loses the chart the operator was
// looking at. Holding the previous lists keeps the selection whenever the new
// range still offers it.
export const useRFactorPickers = (start: string, end: string) =>
	useQuery({
		queryKey: ["rfactorPerStandPickers", start, end],
		queryFn: ({ signal }) => getRFactorPickers({ start, end, signal }),
		enabled: !!start && !!end,
		keepPreviousData: true,
		...NO_POLLING,
	});
